import BookShow from "components/shared/book/show";
import { scenarioFlags } from "helpers/enums";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import cloneDeep from "lodash/cloneDeep";
import pick from "lodash/pick";
import React from "react";
import { config, initialState } from "../formConfig";
import Scenario from "./scenario";
import ScenarioCopy from "./scenario/copy";
import ScenarioQuestions from "./scenarioQuestions";
import { config as questionConfig } from "./scenarioQuestions/form/config";
import { config as answerConfig } from "./scenarioQuestions/scenarioAnswerOptions/form/config";

export class ShowScenario extends BookShow {
    get dropdActions() {
        return [];
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params.id).then((data) =>
            this.setState({
                data,
                initial: cloneDeep(data),
                questionOptions: data.questions.map((item) => ({ label: `#${item.id} ${item.text}`, value: item.id })),
                ...defParams,
            }),
        );
    };

    saveScenario = () => {
        const { scenario } = this.state.data;
        scenario.isLoading = true;
        this.onChange({ name: "scenario", value: scenario });
        const scenarioData = pick(scenario, Object.keys(config));
        return this.props.source.apply(scenarioData).then((data) => {
            if (data) {
                this.getItem(this.props);
            } else {
                scenario.isLoading = false;
                this.onChange({ name: "scenario", value: scenario });
            }
        });
    };

    removeScenario = () => {
        const { scenario } = this.state.data;
        const { modal, mergeParams, back } = this.props;
        return modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы действительно хотите отправить в архив сценарий?",
            onSuccessAction: () => {
                back();
                mergeParams();
            },
            action: () => this.props.source.delItem({ id: scenario.id }),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    createCopy = () => {
        const { scenario } = this.state.data;
        const { modal } = this.props;
        return modal({
            name: "default",
            title: "Создание копии сценария",
            windowMod: "wide",
            CustomBody: ScenarioCopy,
            bodyData: {
                scenario,
                action: this.props.source.copy,
                goToCopy: (id) => this.props.history.push(paths.scenariosShow(id)),
            },
        });
    };

    onChange = ({ name, value }) => {
        this.setState({ data: { ...this.state.data, [name]: value } });
    };

    saveQuestion = (i) => {
        const { questions } = this.state.data;
        questions[i] = { ...questions[i], isLoading: true };
        this.onChange({ name: "questions", value: questions });
        const questionData = pick(questions[i], Object.keys(questionConfig));
        return this.props.source.applyScenarioQuestion(questionData).then((data) => {
            if (data) {
                const promises = questions[i].answerOptions.map((answer) =>
                    this.saveAnswerOption({ ...answer, questionId: data.id }),
                );
                Promise.all(promises).then(() => this.getItem(this.props));
            } else {
                questions[i] = { ...questions[i], isLoading: false };
                this.onChange({ name: "questions", value: questions });
            }
        });
    };

    saveAnswerOption = (answer) => {
        const answerData = pick({ ...answer, scenarioId: this.state.data.scenario.id }, Object.keys(answerConfig));
        return this.props.source.applyScenarioAnswerOption(answerData);
    };

    removeAnswerOption = (questionIndex, answerIndex) => {
        const question = this.state.data.questions[questionIndex];
        const { modal } = this.props;
        return modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы действительно хотите удалить вариант ответа?",
            onSuccessAction: () => {
                question.answerOptions[answerIndex].id && this.getItem(this.props);
            },
            action: () => {
                if (question.answerOptions[answerIndex].id) {
                    this.props.source.deleteScenarioAnswerOption({ id: question.answerOptions[answerIndex].id });
                } else {
                    const { questions } = this.state.data;
                    questions[questionIndex].answerOptions.splice(answerIndex, 1);
                    this.onChange({ name: "questions", value: questions });
                }
            },
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    removeQuestion = (i) => {
        const question = this.state.data.questions[i];
        const { modal } = this.props;
        return modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы действительно хотите удалить вопрос?",
            onSuccessAction: () => {
                this.getItem(this.props);
            },
            action: () =>
                this.props.source.deleteScenarioQuestion({ id: question.id, scenarioId: question.scenarioId }),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    resetScenario = () => {
        this.onChange({ name: "scenario", value: cloneDeep(this.state.initial.scenario) });
    };

    resetQuestion = (i) => {
        const { questions } = this.state.data;
        if (this.state.initial.questions[i]) {
            questions[i] = cloneDeep(this.state.initial.questions[i]);
        } else {
            questions.splice(i, 1);
        }
        this.onChange({ name: "questions", value: questions });
    };

    renderFlags = () => {
        const { scenario } = this.state.data;
        if (!scenario) {
            return null;
        }
        return (
            <div>
                {scenarioFlags.map(({ label, intValue }) => {
                    const hasValue = (scenario.intFlags & intValue) === intValue;
                    return hasValue ? (
                        <span key={intValue} className="badge badge-primary ml-2">
                            {label}
                        </span>
                    ) : null;
                })}
            </div>
        );
    };

    renderHead = () => {
        const { back, title } = this.props;
        return (
            <div className="book-show__head">
                <div className="book-show__close close close--sm" onClick={back} />
                <div className="book-show__title">{title}</div>
                {this.renderFlags()}
            </div>
        );
    };

    renderBody = () => {
        return (
            <div>
                <Scenario
                    scenario={this.state.data.scenario}
                    hasDriverAnswers={this.state.data.hasDriverAnswers}
                    questions={this.state.data.questions}
                    questionOptions={this.state.questionOptions}
                    config={this.props.config}
                    saveScenario={this.saveScenario}
                    onChange={this.onChange}
                    resetScenario={this.resetScenario}
                    removeScenario={this.removeScenario}
                    createCopy={this.createCopy}
                />
                <ScenarioQuestions
                    questions={this.state.data.questions}
                    questionOptions={this.state.questionOptions}
                    hasDriverAnswers={this.state.data.hasDriverAnswers}
                    scenario={this.state.data.scenario}
                    saveQuestion={this.saveQuestion}
                    saveAnswerOption={this.saveAnswerOption}
                    removeAnswerOption={this.removeAnswerOption}
                    onChange={this.onChange}
                    resetQuestion={this.resetQuestion}
                    removeQuestion={this.removeQuestion}
                />
            </div>
        );
    };
}

const ConfiguredShow = (props) => <ShowScenario {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "scenarios");
